module.exports = __webpack_public_path__ + "img/icon_2_30.909ebb23.png";